import { Button } from '@/components/ui/button';
import { coachingRecordDate } from '@/lib/leaderSharedCoaching';
import type { DevelopmentCoverage, DevelopmentMoment } from '@/lib/coachDevelopment';

export function DevelopmentCoverageLine({ coverage }: { coverage: DevelopmentCoverage }) {
  return <div className="space-y-1 text-xs leading-5 text-muted-foreground">
    <p>{coverage.sourcesIncluded} source records included · Coverage window unavailable</p>
    {coverage.unresolvedMoments > 0 ? <p>Some accounts may describe the same event. Event independence is not fully known.</p> : null}
    <p>Coaching conversation dates do not identify the dates of reported workplace events.</p>
  </div>;
}
export function DevelopmentEvidence({ moments, onOpen, busy = false }: {
  moments: DevelopmentMoment[];
  onOpen: (moment: DevelopmentMoment, button: HTMLButtonElement) => void;
  busy?: boolean;
}) {
  return <ol className="space-y-4">{moments.map(moment => <li key={moment.id} className="min-w-0 space-y-2 rounded-xl border p-4">
    <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-muted-foreground">
      <span>{moment.sourceDate ? `${moment.sourceType === 'transcript_upload' ? 'Coaching conversation' : 'Reflection source'} · ${coachingRecordDate(moment.sourceDate)}` : 'Conversation date unavailable'}</span>
      <span>{moment.relation === 'contradicts' ? 'A different account' : 'Supporting account'}</span>
    </div>
    <blockquote className="whitespace-pre-wrap break-words text-base leading-7">“{moment.quote}”</blockquote>
    <p className="text-xs text-muted-foreground">{moment.basis === 'reported' ? 'What you described' : 'Speech from this conversation'} · This excerpt does not independently show behavior at work.</p>
    <Button variant="link" className="min-h-11 px-0" disabled={busy} onClick={event => onOpen(moment, event.currentTarget)}>Read permitted excerpt</Button>
  </li>)}</ol>;
}
